import React, { Suspense } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// i18n'i UYGULAMANIN EN ÜSTÜNDE bir kez yükle!
import "./i18n";

import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Footer from "./pages/Footer";
import "./App.css";

const App = () => {
  return (
    // Çeviriler hazır olana kadar minik bir fallback göster
    <Suspense fallback={<div style={{color:"#e8d1b9", padding:16}}>…</div>}>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
      </Router>
    </Suspense>
  );
};

export default App;
